module.exports = __webpack_public_path__ + "img/3words_title@2x.12dfdae5.png";